import { ENVIRONMENTS } from './constants';

export const isTestEnvironment = () => {
  const hostname = window.location.hostname;
  const origin = window.location.origin;

  return hostname.includes('casumotest') || origin.includes('casumotest');
};

const getEnvVar = (baseName: string) => {
  const testVariableName = `VITE_${baseName}_TEST`;
  const standardVariableName = `VITE_${baseName}`;

  // If in test environment and test-specific variable exists, use it
  if (isTestEnvironment() && import.meta.env[testVariableName]) {
    return import.meta.env[testVariableName];
  }

  // Otherwise, use the standard variable
  return import.meta.env[standardVariableName];
};

const DEFAULT_CONTENT_GATEWAY_URL = 'https://content.casumocdn.com';

const URL = getEnvVar('URL');
const GOOGLE_API_KEY = getEnvVar('GOOGLE_API_KEY');
const CASUMO_BRAND_ID = getEnvVar('CASUMO_BRAND_ID');
const CONTENT_GATEWAY_URL = getEnvVar('CONTENT_GATEWAY_URL') || DEFAULT_CONTENT_GATEWAY_URL;
const API_URL = getEnvVar('API_URL');
const API_URL_SECONDARY = getEnvVar('API_URL_SECONDARY');
const API_URL_SPAIN = getEnvVar('API_URL_SPAIN');
const REACT_APP_VERSION = getEnvVar('REACT_APP_VERSION');
const MFE_URL = getEnvVar('MFE_URL');
const REACT_APP_ENVIRONMENT = getEnvVar('REACT_APP_ENVIRONMENT');

const IS_DEVELOPMENT = REACT_APP_ENVIRONMENT === ENVIRONMENTS.DEV;

export {
  GOOGLE_API_KEY,
  CONTENT_GATEWAY_URL,
  IS_DEVELOPMENT,
  CASUMO_BRAND_ID,
  API_URL,
  API_URL_SECONDARY,
  API_URL_SPAIN,
  URL,
  REACT_APP_VERSION,
  MFE_URL,
  REACT_APP_ENVIRONMENT,
};
